<template>
<!-- Title Page -->
<div>

	<div class="bg-title-page flex-c-m p-t-160 p-b-80 p-l-15 p-r-15"  :style="`background-image: url(${galleryDetailImage[0]})`">
    </div>
    
  <!-- Content page -->
  <section>
    <div class="bread-crumb bo5-b p-t-17 p-b-17">
      <div class="container">
        <router-link to="/" class="txt27">Home</router-link>

        <span class="txt29 m-l-10 m-r-10">/</span>

         <router-link to="/gallery" class="txt27">在地人帶你去</router-link>

        <span class="txt29 m-l-10 m-r-10">/</span>

        <span class="txt29">{{galleryDetailName[0]}}</span>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-8 col-lg-9">
          <div class="p-t-50 p-b-50 bo5-r p-r-50 h-full p-r-0-md bo-none-md">
            <!-- Block4 -->
            <div class="blo4 p-b-63">
              <div class="text-blo4">
                <h4 class="p-b-20">
                  <a href="blog-detail0.html" class="tit9">{{galleryDetailTitle[0]}}</a>
                  <!-- <router-link :to="$route.params/$route.params.galleryInfo" class="tit9">{{galleryDetailTitle[0]}}</router-link> -->
                  
                </h4>
                <p v-html="galleryDetailContent[0]">
                </p>
                <!-- <p>
                  基隆嶼又稱基隆杙，是日治時期基隆八景之一，稱為「杙峰聳翠」，距離基隆只有5公里，與棉花嶼、彭佳嶼及花瓶嶼，為基隆外海4個火山島嶼。
                  <br>從基隆、鄰近的北海岸、東北角海岸線上都可以看到它的面貌，基隆嶼長960公尺、寬400公尺，最高處約有海拔182公尺的小島，尖突的島嶼造型，是基隆外海最顯著的地標。
                </p>
                <p
                  class="p-t-20 p-b-20"
                >基隆嶼景致也因陸上觀賞位置不同而改變，有人說像是一條鯨魚，也有人說是一頭犀牛，島上風光因氣候變化而展現多重美感，島上的「基隆島」燈塔更是台灣最早使用太陽能發電的燈塔。</p> -->
                <div class="pic-blo4 hov-img-zoom bo-rad-10 pos-relative">
                  <a href="blog-detail.html">
                    <img :src="galleryDetailImage[0]" alt="IMG-BLOG">
                  </a>
                </div>
              </div>
            </div>

           
          </div>
        </div>

        <div class="col-md-4 col-lg-3">
          <div class="sidebar2 p-t-50 p-b-80 p-l-20 p-l-0-md p-t-0-md">
      
            <!-- Categories -->
            <div class="categories">
              <h4 class="txt33 bo5-b p-b-35 p-t-58">店家資訊</h4>

              <ul>
                <li class="bo5-b p-t-8 p-b-8">
                  <a href="#" class="txt27">202基隆市中正區正濱路70號</a>
                </li>

                <li class="bo5-b p-t-8 p-b-8">
                  <a href="#" class="txt27">02 2463 4840</a>
                </li>

                <li class="bo5-b p-t-8 p-b-8">
                  <a href="#" class="txt27">
                    星期一 10:00–18:00
                    <br>星期二 10:00–18:00
                    <br>星期三 休息
                    <br>星期四 10:00–18:00
                    <br>星期五 10:00–18:00
                    <br>星期六 09:00–18:00
                    <br>星期日 09:00–18:00
                  </a>
                </li>
              </ul>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
</template>

<style scoped >
.tit9 {
  text-decoration: none;
}
.dis-block {
  text-decoration: none;
}
.bread-crumb a {
  text-decoration: none;
}
.bo5-b a{
  text-decoration: none;
}
</style>
<script >
export default {
  name: "Gallery",
  data(){
    return{
      galleryDetailInfo: [],
      galleryDetailName:[],
      galleryDetailTitle:[],
      galleryDetailContent:[],
      galleryDetailImage:[],
      fits: ['fill', 'contain', 'cover', 'none', 'scale-down']
    }
  },
    mounted: function() {
    return new Promise(
      (
        resolve,
        reject,
        data = this.galleryDetailInfo,
        routePara1 = this.$route.params,
        routePara2 = this.$route.params.galleryInfo,
        name = this.galleryDetailName,
        title = this.galleryDetailTitle,
        content = this.galleryDetailContent,
        image = this.galleryDetailImage
      ) => {
        const readGalleryInfo = firebaseDB.ref("galleries");
        readGalleryInfo
          .orderByChild("galleryName")
          .on("value", function(snapshot) {
            snapshot.forEach(function(childSnapshot) {
              if (childSnapshot.key == routePara2 && routePara1.type == childSnapshot.val().type ) {
                name.push(childSnapshot.val().galleryName);
                title.push(childSnapshot.val().galleryTitle);
                content.push(childSnapshot.val().galleryContent);
                image.push(childSnapshot.val().galleryImage);
              }
              //data.push(childSnapshot.val());
              resolve(snapshot.val());
            });
          });
      }
    );
  }
};
</script>



// WEBPACK FOOTER //
// src/components/GalleryDetail.vue